import React, {useState} from "react";
import {Box, Toolbar, Typography} from "@mui/material";
import {RegistrationApiGet, useGetRegistrationQuery} from "./reg_api";
import RegList, {searchFields} from "./RegList";
import SnackError from "../../components/SnackError";
import InitializeApp from "../../components/InitializeApp";
import Title from "../navigation/Title";
import filterFunction from "../../libs/filterFunction";
import {SearchBox} from "../../components/SearchBox";



type RegListPros = {}

export default ({}: RegListPros) => {

    const [filter, setFilter] = useState("")
    const {data, error, isFetching} = useGetRegistrationQuery({
        active: true,
        sort: [
            {col: "StartTime", dir: "desc"}
        ],
        page:0 ,
        pageSize: 1000
    })

    if (isFetching) {
        return <InitializeApp/>
    }
    if (error) {
        return <SnackError error={error}/>
    }
    const list: Array<RegistrationApiGet> = data && data.result.filter(filterFunction(filter, searchFields)) || [];


    return <>
        <Toolbar sx={{
            display: "flex",
            "&.MuiToolbar-root": {p: 0},
            mb: 1,
            justifyContent: "space-between",
            alignItems: "flex-end",
            flexWrap: "wrap"
        }}>
            <Typography variant={"h4"}>Odprtih prijav: {data?.count}</Typography>
            <SearchBox value={filter} onChange={setFilter}/>
        </Toolbar>
        <Box
        sx={{display: "grid", mt: 2, gridTemplateColumns: "repeat(auto-fill, minmax(450px, 1fr))", gridGap: "1em"}}>
        <Title title={"Odprte prijave"}/>

        <RegList items={list}/>
    </Box>
    </>;
}
